import { render, staticRenderFns } from "./cascaderItem.vue?vue&type=template&id=0c6eefc3&scoped=true&"
import script from "./cascaderItem.vue?vue&type=script&lang=js&"
export * from "./cascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./cascaderItem.vue?vue&type=style&index=0&id=0c6eefc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6eefc3",
  null
  
)

component.options.__file = "cascaderItem.vue"
export default component.exports